import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import wootConstants from 'dashboard/constants/globals';

/** Ações rápidas disparadas pelo menu ⋯ do card. */
export function useKanbanCardActions() {
  const store = useStore();
  const router = useRouter();
  const { t } = useI18n();
  const { accountId } = useAccount();
  const currentUser = useMapGetter('getCurrentUser');

  // ATENÇÃO: a rota declara o param como `conversation_id` (snake_case).
  // Usar `conversationId` faz o vue-router lançar MissingRequiredParam de forma
  // SÍNCRONA (não dá para capturar com .catch).
  const openConversation = conversation =>
    router.push({
      name: 'inbox_conversation',
      params: {
        accountId: accountId.value,
        conversation_id: conversation.id,
      },
    });

  // `assignAgent` já atualiza o store com a resposta do servidor
  // (dispatcha setCurrentChatAssignee internamente).
  const selfAssign = async conversation => {
    const user = currentUser.value;
    if (!user?.id) return;
    await store.dispatch('assignAgent', {
      conversationId: conversation.id,
      agentId: user.id,
    });
    useAlert(t('KANBAN.CARD.ACTIONS.ASSIGNED_TO_ME'));
  };

  const resolve = async conversation => {
    await store.dispatch('toggleStatus', {
      conversationId: conversation.id,
      status: wootConstants.STATUS_TYPE.RESOLVED,
    });
    useAlert(t('KANBAN.CARD.ACTIONS.RESOLVED'));
  };

  // A rota de contato é gated por feature flag/permissão. router.push lança de
  // forma síncrona quando a rota não resolve, por isso try/catch (e não .catch).
  const openContact = conversation => {
    const contactId = conversation.meta?.sender?.id;
    if (!contactId) return;
    try {
      router.push({
        name: 'contacts_edit',
        params: { accountId: accountId.value, contactId },
      });
    } catch (error) {
      openConversation(conversation);
    }
  };

  return { openConversation, selfAssign, resolve, openContact };
}
